var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { withRouter } from 'react-router';
import { MEDIA_QUERIES } from 'shared/style';
var RootDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([" \n  width: 100%;\n  ", " {\n    height: 100%;\n  }\n  ", " {\n    height: 80vh;\n  }\n  text-align: center;\n  background-size: cover;\n\n  ", "\n\n  > .name {\n    cursor: pointer;\n    ", " {\n      line-height: 80vh;\n    }\n    background: rgba(0, 0, 0, 0.4);\n    color: #fff;\n    font-size: 20px;\n  }\n"], [" \n  width: 100%;\n  ", " {\n    height: 100%;\n  }\n  ", " {\n    height: 80vh;\n  }\n  text-align: center;\n  background-size: cover;\n\n  ",
    "\n\n  > .name {\n    cursor: pointer;\n    ", " {\n      line-height: 80vh;\n    }\n    background: rgba(0, 0, 0, 0.4);\n    color: #fff;\n    font-size: 20px;\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE, function (_a) {
    var bgUrl = _a.product.bgUrl;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-image: url(", ");\n  "], ["\n    background-image: url(", ");\n  "])), bgUrl);
}, MEDIA_QUERIES.PHONE);
var Product = function (props) {
    function goTo() {
        var history = props.history;
        history.push(props.product.link);
    }
    return (React.createElement(RootDiv, __assign({}, props),
        React.createElement("div", { className: "name", onClick: goTo }, props.product.name)));
};
export default withRouter(Product);
var templateObject_1, templateObject_2;
